import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import overflowTooltip from './directives/overflowTooltip'

createApp(App)
  .use(store)
  .use(router)
  .directive('overflow-tooltip', overflowTooltip)
  .mount('#app')
